import axios from '@/libs/api.request'
// 学生端个人信息接口
const personalService = {
  // 本科修改密码
  changePassword (data) {
    return axios.request({
      url: '/ugd/passport/password',
      data,
      method: 'POST'
    })
  }
}

export default personalService
